<template>
<div class="footer">
    <hr>
    <h2><img style="max-width:80px;" v-lazy="'https://dream.ameneko.com/iconImage-min.png'" alt="夢占い辞典ゆめみんのキャラクターアイコン">夢占い辞典ゆめみん</h2>
    <li><router-link :to="{ name: 'about'}">夢占い辞典ゆめみんとは？</router-link></li>
    <li><router-link :to="{ name: 'privacy'}">プライバシーポリシー</router-link></li>
    <blockquote>
      <p>夢は個人に属する神話で、神話は個人を排した夢である</p>
      <p>-ジョーセフ・キャンベル</p>
    </blockquote>
    <p class="copyright">©️2020-夢占い辞典ゆめみん</p>
</div>
  
</template>

<script>
export default {
    name: 'footer',


}
</script>

<style scoped>
.footer{
    text-align: center;
    background-color: #FFFFFF;
    padding-top:8px; 
    padding-bottom: 50px; 
}
hr{
    margin-top: 0;
}
h2{
    padding-bottom:10px;
    font-weight: bold;
}
li {
  font-size: 1.1em;
  padding-bottom: 10px;
  list-style: none;
}
.copyright{
    padding-top:30px;
}
blockquote{
    position:relative;
    border-top:1px solid #7A87B0;
    border-bottom:1px solid #7A87B0;
    padding:10px;
    font-style: italic;
}
blockquote:before{
    position:absolute;
    background-color:#FFFFFF;
    color:#7A87B0;
    font-style: italic;
    line-height:1;
    text-align:center;
    top:-20px;
    left:-10px;
    padding:10px;
    font-size:20px;
}
blockquote:after{
    position:absolute;
    right:-10px;
    bottom:-20px;
    font-style: italic;
    background-color:#FFFFFF;
    padding:10px;
    color:#7A87B0;
    line-height:1;
    text-align:center;
    font-size:20px;
}
blockquote cite {
    display: block;
    padding-right:30px;
    font-size: 0.8rem;
    text-align: right;
    color: #808080;
}

</style>